import { Link } from 'react-router-dom';
import { ChevronRight, Landmark } from 'lucide-react';
import { formatMoney } from '../../lib/format';
import { useDepositSummary } from './api';

/**
 * On /invoices: "3 bank deposits to match · $42,087". Renders NOTHING when no
 * bank is connected or nothing is waiting — an empty notice on every visit
 * would teach people to stop reading it.
 */
export function DepositsNotice() {
  const q = useDepositSummary();
  if (!q.data?.connected || q.data.toReview === 0) return null;
  const { toReview, amount } = q.data;
  return (
    <Link
      to="/invoices/deposits"
      className="flex items-center gap-3 rounded-lg border border-status-open-border bg-status-open-bg px-4 py-2.5 text-body-sm text-status-open transition-colors hover:bg-status-open-bg/70"
    >
      <Landmark className="h-4 w-4 shrink-0" aria-hidden />
      <span className="min-w-0 flex-1">
        <strong>
          {toReview} bank deposit{toReview === 1 ? '' : 's'} to match
        </strong>{' '}
        · <span className="num">{formatMoney(amount, { whole: true })}</span> — confirm which invoices they paid
      </span>
      <ChevronRight className="h-4 w-4 shrink-0" aria-hidden />
    </Link>
  );
}
